declare var require: any;
import "./product-price.template.html";
import { productPriceController } from "./product-price.controller";

export var productPriceComponent = {
  template: require("./product-price.template.html"),
  controller: productPriceController,
  bindings: {
    addToCart: "&",
    product: "="
  }
};



// WEBPACK FOOTER //
// ./src/components/product-price/product-price.ts